import {createFeatureSelector, createSelector} from '@ngrx/store';
import {ModuleState, PageState} from './aufgaben-berechtigungen-checklisten.reducer';
import {ListInputItem} from '../../../shared/sopi-list/sopi-list.model';


export const getModuleState = createFeatureSelector<ModuleState>('AufgabenBerechtigungenChecklistenPage');

export const getPageState = createSelector(getModuleState, (state: ModuleState) => state.page);

export const getChecklistenAufgaben = createSelector(getPageState, (state: PageState) => {
    const res: Array<ListInputItem> = [];
    state.checklistenAufgaben.forEach((cl) => {
        cl.aufgaben.forEach(a => {
            let title = a.titel;
            if (a.berechtigung_benutzer_liste !== null && a.berechtigung_benutzer_liste.length > 0) {
                a.berechtigung_benutzer_liste.forEach(x => title = title + ' ' + x.vorname + ' ' + x.nachname);
            }
            res.push(<ListInputItem>{
                groupId: cl.checkliste.checkliste_id,
                groupTitle: cl.checkliste.titel,
                group: cl,
                groupClass: 'funktionsbereiche',
                itemId: a.aufgabe_id,
                itemTitle: title,
                item: a
            });
        });
    });
    return res;
});

export const getChecklistenAufgabenLaden = createSelector(getPageState, (state: PageState) => state.checklistenAufgabenLaden);
export const getChecklistenAufgabenFehler = createSelector(getPageState, (state: PageState) => state.checklistenAufgabenFehler);

export const getSelectedAufgaben = createSelector(getPageState, (state: PageState) => state.selectedAufgaben);

export const getCurrentFunktionsbereichsId = createSelector(getPageState, (state: PageState) => state.currentFunktionsbereichsId);
